'use-client';
/* Built In Imports */
/* External Imports */
// import { Image } from '@chakra-ui/react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import ContentArea from '../ContentArea';
import { useEffect, useState } from 'react';
import { modifyDatoImgUrlToStatic } from '../utils';

/* Services */

/**
 * Renders the Testimonials component.
 * @param {Object} testimonialsObj component.
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns {ReactElement} Testimonials component.
 */
const Testimonials = ({
    sectionContent,
    myRef,
    region,
    lang,
    width,
    height,
    background,
}) => {

    let [sliderKey, setSliderkey] = useState(0)
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setSliderkey(prev => prev + 1)
        }
        window.addEventListener("resize", handleResize)
        window.removeEventListener("resize", handleResize)
    }, [])

    const settings = {
        dots: true,
        arrows: false,
        speed: 500,      
        autoplay: false,
        autoplaySpeed: 2000,
        centerMode: true,
        slidesToShow: 2.02,
        slidesToScroll: 1.02,
        initialSlide: 0,
        centerPadding: '17px',
        infinite: true,
        responsive: [
            {
                breakpoint: 1600,
                settings: { slidesToShow: 2, slidesToScroll: 1, initialSlide: 0, centerMode: false },
            },
            {
                breakpoint: 1024,
                settings: { slidesToShow: 1.05, slidesToScroll: 1.05, initialSlide: 0, centerMode: true, 
                    centerPadding: '30px', },
            },
            {
                breakpoint: 835,
                settings: { slidesToShow: 1.03, slidesToScroll: 1.03, initialSlide: 0, centerMode: true, 
                    centerPadding: '15px', },
            },
            {
                breakpoint: 450,
                settings: { slidesToShow: 1.1, slidesToScroll: 1.1, initialSlide: 0, centerMode: true, centerPadding: '0px'  },
            },
        ],
         
    appendDots: dots => (
        <div
          style={{
            marginTop: '2rem',
            position: 'static',
          }}
        >
          <ul style={{ margin: '0px' }}> {dots} </ul>
        </div>
      ),
    customPaging: function (i) {     
      return (
        <Text
          className="custom-dot"
          cursor="pointer"
          display="inline-block"
          w={{base: '15px', md: "12px", lg: '15px'}}
          h={{base: '15px', md: "12px", lg: '15px'}}
          bgColor={parseInt(currentSlide)/1 == i/1 ? '#fff' : 'transparent'}
          borderRadius="50%"
          border={'1px solid #fff'}
          transition="all 0.3s ease"
        ></Text>
      );
    },
    };


    // return <></>

    return (
        <Box
            w="100%"
            bgColor="#030040"
            pt={{base: '4rem', md: '6rem', lg: '5rem', xl: '7rem' }}
            pb={{base: '4rem', md: '6rem', xl: '8rem'}}
        >

            <Text
                fontFamily={'var(--AustinMedium)'}
                fontSize={{ base: '34px', md: "60px" }}
                color={'#7B7997'}
                fontWeight={500}
                textAlign={{base: 'left', md: 'center'}}
                lineHeight={{ base: '36px', md: '67px' }}
                mb={{ base: '2rem', md: '4rem', lg: '5rem' }}
                pl={{base:'1rem', md: '0px'}}
            >{sectionContent?.[0]?.title[0]?.titleText}</Text>

            <Box
                cursor={'grab'}
                id={'karmaExcerptTestimonials'}
                maxW="100%"
                w="100%"
                style={{ backgroundColor: background }}   
            >
                <Slider  key={sliderKey} {...settings} m="0" 
                    beforeChange={(current, next) => setCurrentSlide(next)}  >
                    {sectionContent?.[0]?.testimonials?.map(data => {
                        return <Box
                            key={nanoid()}
                            transform={{ base: `translateX(2.5rem)`, md: 'unset'}}
                        >
                            <Flex>
                                <Box w={{ base: '311px', md: '409px', lg: '500px' }} >
                                    {data?.photo?.url && (
                                        <LazyLoadImageComponent
                                            src={modifyDatoImgUrlToStatic(data?.photo?.url)}
                                            alt={data?.photo?.alt}
                                            title={data?.photo?.title}
                                            w={{ base: '311px', md: '409px', lg: '409px', '2xl': '500px' }}
                                            h={{ base: '219px', md: '289px', lg: '289px', '2xl': '353px' }}
                                        />
                                    )}
                                <Flex
                                    display={{base: 'flex', md: 'none'}}
                                    fontFamily={'var(--AustinMedium)'}
                                    flexDir={'column'} justifyContent={'center'}  
                                    w={{ base: '300px'}} pl={'12px'}>
                                    <ContentArea
                                        px={'0px'}
                                        fontWeight={500}
                                        font={{ base: '22px', md: '20px', lg: '24px' }}
                                        mainContent={data?.testimonialText}
                                        region={region}
                                        lang={lang}
                                        color={'#FFFFFF'}
                                        pb={'25px'}
                                        lineHeight={{ base: "26.4px", md: "26px", lg: "26.4px" }}

                                    />
                                    {data?.userName && (
                                        <Box
                                            fontWeight={500}
                                            marginLeft={'15px'}
                                            color={'#B7870C'}
                                            textAlign="left"
                                            fontSize={{ base: '22px', md: '19.64px', lg: '24px' }}
                                        >
                                            {data?.userName}
                                        </Box>
                                    )}
                                </Flex>
                                </Box>
                                <Flex
                                    display={{base: 'none', md: 'flex'}}
                                    fontFamily={'var(--AustinMedium)'}
                                    flexDir={'column'} justifyContent={'center'}  
                                    w={{ base: '100%', md: '350px', lg: '440px', xl: '390px' }} pl={{base:'0px', md: '10px', lg: '0px', xl: '0px', '2xl':'15px'}} >
                                    <ContentArea
                                        fontWeight={500}
                                        font={{ base: '22px', md: '20px', '2xl': '24px' }}
                                        mainContent={data?.testimonialText}
                                        region={region}
                                        lang={lang}
                                        color={'#FFFFFF'}
                                        pb={'25px'}
                                        lineHeight={{ base: "26.4px", md: "26px", lg: "26.4px" }}

                                    />
                                    {data?.userName && (
                                        <Box
                                            fontWeight={500}
                                            marginLeft={'15px'}
                                            color={'#B7870C'}
                                            textAlign="left"
                                            fontSize={{ base: '22px', md: '19.64px', lg: '24px' }}
                                        >
                                            {data?.userName}
                                        </Box>
                                    )}
                                </Flex>
                            </Flex>
                        </Box>
                    })}
                </Slider>
            </Box>
        </Box>
    );
};

export default Testimonials;